// eslint-disable-next-line max-classes-per-file
import { RealTimePlaybackKey } from '@ftr/data-realtime-playback'
import { UpdateSessionAction } from './real-time-sessions.actions'

export class RealTimeSessionsUpdatedEvent {
  static readonly type = '[RealTimeSessions] Sessions Updated'

  constructor(readonly playbackKey: RealTimePlaybackKey) {}
}

export class RealTimeSessionUpdateFailedEvent {
  static readonly type = '[RealTimeSessions] Session Update Failed'

  constructor(
    readonly command: UpdateSessionAction,
    readonly reason: string,
    readonly isResettable: boolean,
    readonly isRetryable: boolean,
  ) {}
}

export class RealTimeSessionUpdateSucceededEvent {
  static readonly type = '[RealTimeSessions] Session Update Succeeded'

  constructor(readonly command: UpdateSessionAction) {}
}
